export function getAuthToken(): string | null {
  return localStorage.getItem("accessToken")
}

export function setAuthToken(token: string | null): void {
  if (!token) {
    localStorage.removeItem("accessToken")
  } else {
    localStorage.setItem("accessToken", token)
  }
}
